import type { BadgeTone } from "../components/index.js";

/**
 * Mapa do status de rastreamento por caixa → rótulo pt-BR + tom de badge
 * (Design.md §6.5). A fonte é o `trackingNumberValidationStatus` do SPD da
 * Amazon (getShipment → spdTrackingItems), um enum de VALIDAÇÃO — não um texto
 * "Confirmado". Por isso traduzimos o VALOR (verde só quando confirmado) em vez
 * de sobrescrever o dado com um literal. Lógica PURA, testável.
 */
export interface TrackingBadge {
  label: string;
  tone: BadgeTone;
}

/**
 * `null` quando ainda não há status (renderizar "—"). Valores desconhecidos
 * caem num fallback fiel (mostra o valor cru, tom neutro) — nunca escondem o
 * dado real sob um rótulo fixo.
 */
export function trackingStatusBadge(status: string | null): TrackingBadge | null {
  if (status === null || status.trim().length === 0) {
    return null;
  }
  switch (status) {
    case "VALIDATED":
      return { label: "✓ Confirmado", tone: "green" };
    case "NOT_VALIDATED":
      return { label: "Não validado", tone: "amber" };
    default:
      return { label: status, tone: "gray" };
  }
}
